import { useEffect } from "react";
import { retry } from "@whatslly/commons/utils";

let svgText: string;
export const SVG_URL = `https://api.tuvis.com/integrations/api/integrations-icons.svg`;

const fetchSVG = async () => {
  return await retry<Promise<string | undefined>>(
    async (signal) => {
      const res = await fetch(SVG_URL, { signal });
      if (res.ok) {
        return await res.text();
      }
      throw new Error("failed to load svg file");
    },
    { maxRetry: Number.MAX_SAFE_INTEGER, delayBetweenRetryMs: 2_000 }
  );
};

export const injectSVG = async (fetchSVGFunction = fetchSVG) => {
  const text = await fetchSVGFunction();
  if (!text) {
    console.error("failed to load svg file");
    return;
  }
  svgText ??= text;
  const doc = new DOMParser().parseFromString(svgText, "text/html");
  if (doc.body.firstElementChild) {
    doc.body.firstElementChild.setAttribute("style", "display: none");
    doc.body.firstElementChild.setAttribute("id", "svg-sprite");
    document.body.appendChild(doc.body.firstElementChild);
  }
};

export const useSVG = () => {
  useEffect(() => {
    injectSVG();
  }, []);
};
